import React from 'react';
import axios from 'axios';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import DatasetCard from './dataset_card.jsx';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    width: '100%',
  },
  headerPanel: {
   background: 'purple',
   width: '100%',
   display: 'flex',
   flexDirection: 'row',
  },
  column: {
    width: '25%',
    alignItems: 'center',

      display: 'inline-block',
    flexBasis: '25%',
  },
  gridContainer: {
      marginTop: '15px',
  },
  imagesList: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-around',
      flexFlow: 'row wrap',

      listStyleType: 'none',
      paddingLeft: 0,
  },
});

class Datasets extends React.Component {
    state = {
        images: [],
        loading: true
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/datasets`)
            .then(res => {
                console.log("DATASETS", res);
                const datasets = res.data;
                this.setState({ datasets, loading: false });
            })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Typography variant="headline">Datasets</Typography>
                <Typography variant="subheading">These are managed datasets</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    {this.state.datasets && this.state.datasets.map((ds, i) => 
                        <Grid item key={i}>
                            <DatasetCard dataset={ds}  />
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Datasets);



// WEBPACK FOOTER //
// ./src/components/datasets.jsx